<script setup>
  import { ref, computed } from 'vue';
  import { useSpotStore } from '@/stores/SpotStore';
  import { useUserStore } from '@/stores/UserStore';
  import { useCompleteReportStore } from '@/stores/CompleteReportStore';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import SpotHeaderTitle from '@/components/SpotHeaderTitle.vue';
  import SpotHeaderStatusMessage from '@/components/SpotHeaderStatusMessage.vue';
  import SpotHeaderSpotMessage from '@/components/SpotHeaderSpotMessage.vue';
  import SpotHeaderPrimaryActionList from '@/components/SpotHeaderPrimaryActionList.vue';
  import ToolbarHeaderActionMenuPopup from '@/components/ToolbarHeaderActionMenuPopup.vue';
  import CompleteReportHeaderSecondaryActions from '@/components/CompleteReportHeaderSecondaryActions.vue';
  import FavoriteSpotUserTip from "@/components/FavoriteSpotUserTip.vue";
  import ModalSaveSpotToProfile from '@/components/ModalSaveSpotToProfile.vue';
  import ModalWindAlertManage from '@/components/ModalWindAlertManage.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();      

  const spotStore = useSpotStore();
  const userStore = useUserStore();
  const completeReportStore = useCompleteReportStore();

  const props = defineProps({
    showFavoritesUserTip: {
      type: Boolean,
      default: true
    }
  });    

  const isDesktop = useMediaQuery('(min-width: 840px)');
  const isSmallDevice = useMediaQuery('(max-width: 539px)');

  const headerButtons = ['favorite', 'map', 'alerts', 'widgets'];  
  
  const showProfileModal = ref(false);
  const showManageAlertModal = ref(false);

  const showUserTip = computed(() => userStore.memberLevel > 0 && !isSmallDevice.value && !isDesktop.value && !$WEB_VIEW && props.showFavoritesUserTip);    

  function handleManageAlertModalClose() {
    showManageAlertModal.value = false;
  } 

  function handleShowProfileModal() {
    showProfileModal.value = true;
  }
</script>
<template>
    <header class="jwx-toolbar-header">
      <div class="jwx-toolbar-header__main-content">
        <SpotHeaderTitle
          :spot="spotStore.spot"
          :isNowcastingSpot="spotStore.isNowcast"
        />
        <SpotHeaderStatusMessage :statusMessage="spotStore.statusMessage" />
  
        <SpotHeaderPrimaryActionList
          v-if="isDesktop"
          @update:showProfileModal="handleShowProfileModal"
          @showAlertManageModal="showManageAlertModal = true"
          :buttons="headerButtons"
        />

        <ToolbarHeaderActionMenuPopup v-else>
          <template #menu-content>
            <SpotHeaderPrimaryActionList
              @update:showProfileModal="handleShowProfileModal"
              :buttons="headerButtons"
            />
            <CompleteReportHeaderSecondaryActions
              v-if="userStore.nonTrialMemberLevel > -1"
              v-model:showSettingsModal="completeReportStore.showSettingsModal"
            />
          </template>
          <template #misc>
            <FavoriteSpotUserTip
              v-if="showUserTip"
              :menu="true"
              alignment="right"
            />
          </template>
        </ToolbarHeaderActionMenuPopup>

        <SpotHeaderSpotMessage :spotMessage="spotStore.spotMessage" />
      </div>

      <CompleteReportHeaderSecondaryActions
        v-if="isDesktop && userStore.nonTrialMemberLevel > -1"
        v-model:showSettingsModal="completeReportStore.showSettingsModal"
      />
    </header>

    <ModalWindAlertManage
      v-if="spotStore.spot"
      :show="showManageAlertModal"
      :spotId="spotStore.spotId"
      :spotName="spotStore.spotName"
      :lat="spotStore.lat"
      :lon="spotStore.lon"
      @close="handleManageAlertModalClose"
    />       

    <ModalSaveSpotToProfile
      v-model:showProfileModal="showProfileModal"
      v-if="showProfileModal"
      :profiles="userStore.userProfiles.profiles"
    />
</template>